export default __webpack_public_path__ + "static/media/Shocksand Belt.ab1c7b37.jpg";